import React from "react";

/**
 * A compact CTA block with quick-access link buttons for page topics.
 * Used on Blog and Podcast pages for faster navigation to titles/episodes.
 */
export default function TopicQuickLinks({ title, subtitle, children }) {
  if (!children || (Array.isArray(children) && children.length === 0)) return null;
  return (
    <section className="rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/5 to-accent/5 p-5 sm:p-6 mb-8">
      <h2 className="font-heading font-bold text-base sm:text-lg mb-1">{title}</h2>
      {subtitle && <p className="text-sm text-muted-foreground mb-4">{subtitle}</p>}
      <div className="flex flex-wrap gap-2">{children}</div>
    </section>
  );
}